import type { IComponentController, IScope } from "angular";
import { noop } from "angular";
import "angular-translate";

import type { IModalService } from "App/Modules/Services";
import type { IProfileService } from "App/Modules/Auth";
import type { IProfile } from "App/Modules/Models";

import "./EditForm/LocalizationEditComponent";

export default class ProfileLocalizationComponentController implements IComponentController {
    public static $inject = ["$scope", "$translate", "mmModalService", "mmProfileService"];

    public profile: IProfile;

    public localizationStrings: { language: string; locale: string; timeZone: string };

    constructor(
        private readonly $scope: IScope,
        private readonly $translate: angular.translate.ITranslateService,
        private readonly modalService: IModalService,
        private readonly profileService: IProfileService,
    ) {}

    public $onInit() {
        this.profileService.profileObservable().subscribe((p) => {
            if (p !== null) {
                const lang = `Entities.Language.${p.language.key}`;
                const locale = `Entities.Locale.${p.locale}`;
                const tz = `Entities.TimeZone.${p.timeZone.name}`;

                this.$translate([
                    `Entities.Language.${p.language.key}`,
                    `Entities.Locale.${p.locale}`,
                    `Entities.TimeZone.${p.timeZone.name}`,
                ]).then(
                    (strings) => {
                        this.localizationStrings = {
                            language: strings[lang],
                            locale: strings[locale],
                            timeZone: strings[tz],
                        };
                    },
                    () => {},
                );
            }
        });
    }

    public editLanguage() {
        this.modalService.open("mmLocalizationEdit", this.profile).subscribe(noop, () => noop);
    }
}
